var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPdfFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 335 381",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "icon_PDF_file"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M51.791,356.646L51.791,23.99L204.497,23.99L282.646,102.066L282.646,356.646L51.791,356.646Z",
    style: {
      fill: "white"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M201.186,31.99L274.646,105.383L274.646,348.647L59.791,348.647L59.791,31.99L201.186,31.99M207.809,15.99L43.791,15.99L43.791,364.647L290.645,364.647L290.645,98.75L207.809,15.99Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M51.791,356.646L51.791,23.99L204.497,23.99L206.309,25.8L206.309,100.327L280.904,100.327L282.646,102.066L282.646,356.646L51.791,356.646Z",
    style: {
      fill: "white"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M198.309,31.99L198.309,108.327L274.646,108.327L274.646,348.647L59.791,348.647L59.791,31.99L198.309,31.99M207.809,15.99L43.791,15.99L43.791,364.647L290.645,364.647L290.645,98.75L284.215,92.326L214.308,92.326L214.308,22.484L207.809,15.99Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M219.643,87.75L219.643,48.667L258.309,86.38L258.309,87.75L219.643,87.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.643,67.646L240.053,79.75L227.643,79.75L227.643,67.646M222.641,40.417L211.643,40.417L211.643,95.75L266.309,95.75L266.309,83.008L222.641,40.417Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.544,284.49L22.544,167.682L37.291,152.935L37.291,171.489L297.146,171.489L297.146,152.935L311.893,167.682L311.893,284.49L22.544,284.49Z",
    style: {
      fill: "rgb(237,28,36)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.646,168.627L305.393,170.374L305.393,277.99L29.044,277.99L29.044,170.374L30.791,168.627L30.791,177.989L303.645,177.989L303.645,168.627M290.646,137.242L290.646,164.989L43.791,164.989L43.791,137.242L16.044,164.989L16.044,290.99L318.393,290.99L318.393,164.989L290.646,137.242Z",
    style: {
      fill: "rgb(237,28,36)"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 52.096,
    y: 189.324,
    width: 232.826,
    height: 87.834,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,52.0957,271.662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.639,-76.545L42.4,-76.545C52.141,-76.545 59.618,-74.384 64.83,-70.06C70.043,-65.736 72.649,-59.575 72.649,-51.577C72.649,-43.545 70.043,-37.367 64.83,-33.043C59.618,-28.719 52.141,-26.558 42.4,-26.558L29.377,-26.558L29.377,0L9.639,0L9.639,-76.545ZM29.377,-62.241L29.377,-40.862L40.298,-40.862C44.126,-40.862 47.083,-41.793 49.167,-43.656C51.252,-45.519 52.295,-48.159 52.295,-51.577C52.295,-54.995 51.252,-57.627 49.167,-59.473C47.083,-61.318 44.126,-62.241 40.298,-62.241L29.377,-62.241Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.333,-61.626L106.333,-14.919L113.408,-14.919C121.475,-14.919 127.635,-16.919 131.891,-20.918C136.146,-24.917 138.274,-30.728 138.274,-38.35C138.274,-45.938 136.155,-51.714 131.917,-55.679C127.678,-59.644 121.509,-61.626 113.408,-61.626L106.333,-61.626ZM86.594,-76.545L107.41,-76.545C119.031,-76.545 127.687,-75.717 133.378,-74.059C139.069,-72.401 143.948,-69.59 148.015,-65.625C151.604,-62.173 154.27,-58.191 156.013,-53.679C157.756,-49.167 158.628,-44.058 158.628,-38.35C158.628,-32.573 157.756,-27.421 156.013,-22.892C154.27,-18.363 151.604,-14.373 148.015,-10.92C143.914,-6.956 138.992,-4.144 133.25,-2.487C127.507,-0.829 118.894,0 107.41,0L86.594,0L86.594,-76.545Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.752,-76.545L227.021,-76.545L227.021,-61.626L193.491,-61.626L193.491,-47.373L225.022,-47.373L225.022,-32.454L193.491,-32.454L193.491,0L173.752,0L173.752,-76.545Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdfFile);
export default __webpack_public_path__ + "static/media/icon_pdf_file.4bbfa9c6f6f630131124e46b921880cb.svg";
export { ForwardRef as ReactComponent };